/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { getFile, hideModal } from "actions";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { withRouter } from "react-router-dom";
import { Trans } from "react-i18next";

class GuidebarModalBody extends Component {
  state = { profileImageFetched: false, file: null };

  componentDidMount() {
    if (this.props.profile && this.props.profile.imagePath) {
      this.props.getFile(
        this.props.profile.imagePath,
        this.onBegin,
        this.onFileSuccess,
        this.onError
      );
    }
  }

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onFileSuccess = (file) => {
    this.props.onProcessEnd();
    this.setState({
      profileImageFetched: true,
      file: file,
    });
  };

  stopBubbleUp = (e) => {
    e.stopPropagation();
  };

  handleEvolutionPlanRedirect = (profileId) => {
    this.props.hideModal();
    this.props.history.push(`/evolution-plan/${profileId}`);
  };

  renderImage = () => {
    return {
      backgroundImage: `url(${this.state.file
        ? this.state.file.binary
        : "img/ford-gelisim-akademisi-avatar.svg"
        })`,
    };
  };

  render() {
    if (!this.props.profile) {
      return this.props.spinner;
    }

    return (
      <>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 quideProfileArea">
              <div className="duyuruButton">
                <div className="quideProfileTitleArea">
                  <div
                    className="quideProfileImage"
                    style={this.renderImage()}
                  ></div>
                  <div className="quideProfileInfo">
                    <div className="quideProfileName">
                      {this.props.profile.fullname}
                    </div>
                    <div className="quideProfileTitle">
                      {this.props.profile.position}
                    </div>
                  </div>
                </div>
                {!this.props.profile.isOtosanContact && (
                  <div
                    className="quideProfileArrow"
                    onClick={() =>
                      this.handleEvolutionPlanRedirect(this.props.profile.id)
                    }
                  >
                    <span className="iconmford fo-icon-keyboard-arrow-right"></span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="line-seperator"></div>
          <div className="row">
            <div className="col-12">
              <table className="table guideDetailTable">
                <tbody>
                  <tr>
                    <td><Trans desc="Departman">10559</Trans></td>
                    <td>{this.props.profile.department}</td>
                  </tr>
                  <tr>
                    <td><Trans desc="Birim">10561</Trans></td>
                    <td>{this.props.profile.unit}</td>
                  </tr>
                  <tr>
                    <td><Trans desc="E-Posta Adresi">10560</Trans></td>
                    <td>
                      <a
                        className="btn-guide-contact"
                        href={`mailto:${this.props.profile.email}`}
                        onClick={(e) => this.stopBubbleUp(e)}
                      >
                        <span className="iconmford fo-icon-contact-mail"></span>{" "}
                        {this.props.profile.email}
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td><Trans desc="Telefon No">10562</Trans></td>
                    <td>
                      <a
                        className="btn-guide-contact"
                        href={`tel:${this.props.profile.companyPhone}`}
                        onClick={(e) => this.stopBubbleUp(e)}
                      >
                        <span className="iconmford fo-icon-phone"></span>{" "}
                        {this.props.profile.companyPhone}
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td><Trans desc="Dahili Hat">10563</Trans></td>
                    <td>{this.props.profile.companyPhoneExtension}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-default"
            onClick={this.props.hideModal}
          >
            <Trans desc="Kapat">10564</Trans>
          </button>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    profile: state.guide.data.find((p) => {
      return p.id === ownProps.id;
    }),
  };
};

export default connect(mapStateToProps, { getFile, hideModal })(
  containsLongRunningProcess(withRouter(GuidebarModalBody))
);

export const GuidebarModalTitle = (props) => {
  return (
    <>
      <h5 className="modal-title"><Trans desc="Rehber Arama Sonuç">10558</Trans></h5>
    </>
  );
};
